import { atom, selector } from "recoil";

const sidebarisexpandAtom = atom({
  key: "sidebarisexpandState",
  default: true,
});

const panelAtom = atom({
  key: "panelState",
  default: "home",
});

const userState = atom({
  key: "userState",
  default: {
    name: null,
    email: null,
    level: null,
    uid: null,
    province: null,
    isAuthenticated: false,
  },
});

export const tahunAnggaranAtom = atom({
  key: "selectedTahunAnggaranState",
  default: "2064924627", // initially no selection
  effects: [
    ({ setSelf, onSet }) => {
      // Load from localStorage (if exists)
      const savedValue = localStorage.getItem("tahunAnggaran");
      if (savedValue != null) {
        setSelf(savedValue);
      }

      // Save to localStorage whenever atom changes
      onSet((newValue, _, isReset) => {
        if (isReset) {
          localStorage.removeItem("tahunAnggaran");
        } else {
          localStorage.setItem("tahunAnggaran", newValue);
        }
      });
    },
  ],
});

export const sheetURLSelector = selector({
  key: "sheetURLSelector",
  get: ({ get }) => {
    const gid = get(tahunAnggaranAtom);
    return `https://docs.google.com/spreadsheets/d/1vTuEXERFF-i-QBj6Vse912Hkv3J5SWhblcPPRIKWuew/gviz/tq?tqx=out:csv&gid=${gid}`;
  },
});

export const selectedProvincesState = atom({
  key: "selectedProvincesState",
  default: [], // initially no selection
});
export const selectedPemdaState = atom({
  key: "selectedPemdaState",
  default: [],
});

export const selectedJenisTkdState = atom({
  key: "selectedJenisTkdState",
  default: [],
});

export const months = atom({
  key: "months", // unique ID (with respect to other atoms/selectors)
  default: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Des",
  ],
});

export const startMonthAtom = atom({
  key: "startMonthAtom",
  default: "Jan",
});

export const endMonthAtom = atom({
  key: "endMonthAtom",
  default: "Des",
});

export { sidebarisexpandAtom, panelAtom, userState };
